// C# source of truth for server/email: src/Configuration/Branding/AppBranding.cs (BrandName)
export const brandName = "MAR360";

export const getDocumentTitle = (pageTitle: string) =>
    pageTitle ? `${brandName}: ${pageTitle}` : brandName;
